import { RemoteShellWebComponent } from './component/RemoteShellWebComponent';
import { WEB_COMPONENT_REMOTE_SHELL } from '../../webcomponents.constants';

export { RemoteShellWebComponent };

window.customElements.define(WEB_COMPONENT_REMOTE_SHELL, RemoteShellWebComponent);
